import { render, staticRenderFns } from "./BallotVoteComponent.vue?vue&type=template&id=7274853c&scoped=true&"
import script from "./BallotVoteComponent.vue?vue&type=script&lang=js&"
export * from "./BallotVoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./BallotVoteComponent.vue?vue&type=style&index=0&id=7274853c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274853c",
  null
  
)

export default component.exports